export default {
    state:{
        token:''
    },
    mutations:{
        SET_Token(state:any,val:any){
            console.log(666)
            state.token=val
        }
    },
    actions:{
    },
    namespaced:true//模块化命名

}